import { Edit } from "@mui/icons-material"
import { IconButton } from "@mui/material"

export default function IconButtonEdit({ onClick, ...props }: { onClick: () => void }) {
  return (
    <IconButton
      size="small"
      sx={{
        "&:hover": {
          color: "grey.900",
        },
      }}
      onClick={onClick}
      aria-label="edit"
      {...props}
    >
      <Edit />
    </IconButton>
  )
}
